import { type PropsWithChildren } from 'react';

import * as css from './Page.css';

export function Page({ children }: PropsWithChildren) {
    return <div className={css.page}>{children}</div>;
}
